export default __webpack_public_path__ + "media/images/svg/linkedin-social-4652bbab165437089edcc152413ea00b.svg";